const checkIn = () => import('./checkIn');

const specialRouter = [
  {
    path: '/special/checkIn', name: 'checkIn', component: checkIn, meta: { c: 'special', a: 'checkIn' }
  },
];

export default specialRouter;
